import { Link } from 'react-router-dom'

export function ForbiddenPage() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-muted">
			<div className="text-center max-w-md">
				<div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
					<svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
						/>
					</svg>
				</div>
				<h1 className="text-2xl font-bold text-foreground">Access Denied</h1>
				<p className="mt-3 text-muted-foreground">You don't have permission to access this page.</p>
				<Link to="/" className="mt-6 inline-block px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">
					Go to Dashboard
				</Link>
			</div>
		</div>
	)
}
